export default function Services() {
  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: 'LED Bulb Repair',
      description: 'Sabhi prakar ke LED bulbs ki repair'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Ceiling & Table Fan Repair',
      description: 'Ceiling fan aur table fan ki complete repair'
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Electric Iron Repair',
      description: 'Electric press ki testing aur repair'
    },
    {
      icon: 'ri-battery-charge-line',
      title: 'Mobile Charger Repair',
      description: 'Mobile charger aur adapter repair'
    },
    {
      icon: 'ri-volume-up-line',
      title: 'Speaker Repair',
      description: 'Bluetooth aur wired speakers ki repair'
    },
    {
      icon: 'ri-scissors-line',
      title: 'Hair Dryer Repair',
      description: 'Hair dryer ki complete servicing'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'BP Machine Repair',
      description: 'Blood pressure machine ki repair'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Body Massager Repair',
      description: 'Electric massager ki repair'
    },
    {
      icon: 'ri-tools-line',
      title: 'Other Small Electronics',
      description: 'Ghar ke chhote electronic devices'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Hamare Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hum chhote electronics aur personal devices ki repair karte hain
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-orange-200 cursor-pointer transform hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-lg mb-4 group-hover:bg-orange-500 transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-orange-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-lg">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-2xl text-orange-500 mt-1"></i>
            <div>
              <h4 className="font-semibold text-gray-900 mb-2 text-lg">Important Note:</h4>
              <p className="text-gray-700">
                <strong>Sabhi repair services sirf shop par hi di jaati hain.</strong> Home service available nahi hai. Kripya apne device ko shop par laayein.
              </p>
              <p className="text-gray-700 mt-2">
                <strong></strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
